// extracted by mini-css-extract-plugin
export default {"section":"addExerciseToUser_section__AsadB","header":"addExerciseToUser_header__GMZ4e","exercises":"addExerciseToUser_exercises__i2qAQ","list":"addExerciseToUser_list__DAiZR"};